var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "input",
    class: {
      attachment: _vm.attachment
    },
    attrs: {
      "data-type": "input"
    }
  }, [_c('input', {
    directives: [{
      name: "capusta-money",
      rawName: "v-capusta-money",
      value: _vm.currency,
      expression: "currency"
    }],
    ref: "inputPrice",
    class: {
      'invalid': _vm.$v.$error || this.error
    },
    attrs: {
      "id": _vm.inputId,
      "type": "tel",
      "size": _vm.inputSize,
      "title": _vm.inputTitle,
      "placeholder": _vm.placeholder,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.handleInput,
      "focus": function focus($event) {
        return _vm.$emit('focus');
      }
    }
  }), _c('label', {
    attrs: {
      "for": _vm.inputId
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.inputName))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }